<template>
  <div>
    <div slot="title">
      <h2 class="label-black">Detalles del Evaluado</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:20px">
          <div class="col-2">
            <router-link v-if="infoPersona!=null" :to="{ name: 'DetalleDeEvaluaciones', params: {infoPersona: infoPersona } }">
              <button type="button" class="form-control btn-custom"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:50px">Regresar</span></button>
            </router-link>
            <button type="button" class="form-control btn-custom" v-else @click="$router.go(-1)"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:50px">Regresar</span></button>
          </div>
        </div>
        <div class="row">
          <div class="col-3" style="border-right:solid;padding-right:20px;">
            <div class="row">
              <div class="col-12"><h4><span class="col-form-label label-black">Persona Evaluada</span></h4></div>
            </div>
            <div class="row" style="margin-top:10px;margin-bottom:10px;">
              <div class="col-12 d-flex justify-content-center" style="overflow:hidden">
                <img src="../../../assets/usuario-sin-foto.png" class="thumb" />
                <!--<i data-v-6bbe8d3f="" class="fas fa-user-tie prof-pic"></i>-->
              </div>
              <div class="col-12">
                <div class="row"><span class="col-form-label label-black"><b>Evaluado : </b>{{nombreEvaluado}}</span></div>
                <div class="row"><span class="col-form-label label-black"><b>Estatus : </b>{{estatus}}</span></div>
                <div class="row"><span class="col-form-label label-black"><b>Sección : </b>{{seccion}}</span></div>
                <div class="row"><span class="col-form-label label-black"><b>Departamento : </b>{{departamento}}</span></div>
                <div class="row"><span class="col-form-label label-black"><b>Puesto : </b>{{puesto}}</span></div>
                <div class="row"><span class="col-form-label label-black"><b>Tipo Puesto : </b>{{tipoPuesto}}</span></div>
                <div class="row"><span class="col-form-label label-black"><b>Periodo a Evaluar : </b>{{periodoEvaluacion}}</span></div>
              </div>
            </div>
          </div>
          <div class="col-9">
            <div class="row">
              <div class="col-5">
                <h5  class="label-black">
                  <span class="col-form-label">
                    Evaluadores Asignados <span class="badge badge-light">{{evaluadoresAsignados}}</span>
                  </span>
                </h5>
              </div>
              <div class="col-3"></div>
            </div>

            <div class="row">
              <div class="col-12">
                <ul class="nav nav-tabs" id="tabAltaUsuario" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="Evaluadores-tab" data-toggle="tab" href="#Evaluadores" role="tab" aria-controls="Evaluadores" aria-selected="true">Evaluadores</a>
                  </li>
                  <li class="nav-item" v-if="terminado">
                    <a class="nav-link" id="Comentarios-tab" data-toggle="tab" href="#Comentarios" role="tab" aria-controls="Comentarios" aria-selected="false">Comentarios</a>
                  </li>
                  <li class="nav-item" v-if="terminado">
                    <a class="nav-link" id="Resultados-tab" data-toggle="tab" href="#Resultados" role="tab" aria-controls="Resultados" aria-selected="false">Resultados</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="Evaluadores" role="tabpanel" aria-labelledby="general-tab">
                <div class="row" style="margin-top:30px;">
                  <div class="col-12">
                    <table class="table table-striped table-light table-hover" id="tablaEvaluadores2">
                      <thead class="thead-custom">
                        <tr>
                          <th class="text-center">Nombre de evaluador</th>
                          <th class="text-center">Puesto</th>
                          <th class="text-center">Area</th>
                          <th class="text-center">Tipo de Evaluador</th>
                          <th class="text-center">Estatus de evaluación</th>
                          <th class="text-center">Acciones</th>
                        </tr>
                      </thead>
                      <tbody class='text-dark'>
                        <tr v-for='evaluador in evaluadores'>
                          <td>{{evaluador.Evaluador.NombreCompleto}}</td>
                          <td>{{evaluador.Evaluador.Puesto}}</td>
                          <td>{{evaluador.Evaluador.Seccion}} - {{evaluador.Evaluador.Seccion}}</td>
                          <td>{{evaluador.TipoEvaluador}} / {{evaluador.FormatoCuestionario}}</td>
                          <td>{{evaluador.EstatusEvaluacion}}</td>
                          <td class='d-flex justify-content-around'>
                            <i class='fa fa-ban' v-if="evaluador.EstatusEvaluacion == 'Contestada'" @click="CancelarResultadoEvaluacion(evaluador.idCuestionario)" title="Cancelar resultado de la evaluación" />
                            <i class='fa fa-trash-alt' @click="QuitarEvaluador(evaluador.idCuestionario)" title="Quitar evaluador" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show" id="Comentarios" role="tabpanel" aria-labelledby="general-tab">
                <div class="row" style="margin-top:30px;">
                  <div class="col-12">
                    <table class="table table-striped table-light table-hover" id="tablaComentarios">
                      <thead class="thead-custom">
                        <tr>
                          <th class="text-center">Comentarios</th>
                        </tr>
                      </thead>
                      <tbody class='text-dark'>
                        <tr>
                          <td>
                            <ul v-for="evaluador in evaluadores">
                              <li v-if="evaluador.Observaciones != null && evaluador.Observaciones != ''">{{evaluador.Observaciones}}</li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" v-if="terminado" id="Resultados" role="tabpanel" aria-labelledby="Resultados-tab">
                <div class="row">
                  <div class="col-12">
                    <ul class="nav nav-tabs" id="tabResultados" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" id="Poligono-tab" data-toggle="tab" href="#Poligono" role="tab" aria-controls="Poligono" aria-selected="true">Poligono</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="Barras-tab" data-toggle="tab" href="#Barras" role="tab" aria-controls="Barras" aria-selected="false">Barras</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="Poligono" role="tabpanel" aria-labelledby="Poligono-tab">
                    <div class="row" style="margin-top:30px; margin-left:20px;">
                      <div class="col-12">
                        <highcharts :options="chartOptions" style="min-height:500px"></highcharts>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="Barras" role="tabpanel" aria-labelledby="Barras-tab">
                    <div class="row" style="margin-top:30px; margin-left:20px;">
                      <div class="col-12">
                        <highcharts :options="chartOptions2" style="min-height:500px"></highcharts>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import Vuex from 'vuex'
  import store from '@/store/index'
  import highcharts from '@/../static/js/highchart'

  export default {
    props: ['idEvaluacion', 'infoPersona'],//Recibe como parametro el id de evaluación
    data() {
      return this.datosIniciales()
    },
    components: {
      highcharts
    },
    methods: {
      datosIniciales() {
        return {//asigna los valores iniciales del data
          nombreEvaluado: "",//Almacena el nombre del evaluado
          estatus: "Desconocido",//Almacena el estatusde la evaluación
          seccion: "",//Almacena la sección del evaluado
          departamento: "",//Almacena el departamento del evaluado
          puesto: "",//Almacena el puesto del evaluado
          tipoPuesto: "",//Almacena el tipo de contrato del evaluado
          periodoEvaluacion: "",//Almacena el periodo de evaluación
          evaluadoresAsignados: 0,//Almacena la cantidad de evaluadores asignados
          evaluadoId: 0,//Guarda el id del evaluado
          asignadosIniciales: false,
          evaluadores: [],
          comentario: "",
          terminado: false,
          comentado: false,
          chartOptions: {
            chart: {
              renderTo: 'container',
              polar: true,
              type: 'line',
              backgroundColor: 'transparent'
            },
            title: {
              text: 'Resultado de Evaluación',
              x: 0,
              style: {
                color: "#fff"
              }
            },
            pane: {
              size: '90%'
            },
            xAxis: {
              categories: ['IntraPersonal', 'Interpersonal', 'Desarrollo de tareas', 'Entorno', 'Gerencia'],
              tickmarkPlacement: 'on',
              lineWidth: 0,
              labels: {
                style: {
                  color: "#fff"
                }
              }
            },

            yAxis: {
              tickInterval: 1,
              gridLineInterpolation: 'polygon',
              lineWidth: 0,
              min: 0,
              max: 4,
              labels: {
                style: {
                  color: "#fff"
                }
              }
            },

            tooltip: {
              shared: true
            },

            legend: {
              align: 'right',
              verticalAlign: 'top',
              y: 80,
              layout: 'vertical',
              itemStyle: {
                color: '#FFF'
              }
            },
            exporting: {
              buttons: {
                contextButton: {
                  symbolStroke: "white",
                  theme: {
                    fill: "transparent"
                  }
                }
              }
            },

            series: [{
              name: 'Perfil del Puesto',
              type: 'line',
              dashStyle: 'ShortDash',
              data: [3, 3.4, 2.5, 3.1, 3.5],
              pointPlacement: 'on',
              color: '#FF11AA',
            },
            {
              name: 'Resultado',
              type: 'line',
              data: [3.5, 3, 3.2, 2.3, 4],
              pointPlacement: 'on',
              color: '#0088FF'
            }
            ]

          },
          chartOptions2: {
            chart: {
              type: 'column',
              backgroundColor: 'transparent'
            },
            title: {
              text: 'Resultado de Evaluación',
              style: {
                color: "#fff"
              }
            },
            subtitle: {
              text: 'Competencias',
              style: {
                color: "#fff"
              }
            },
            xAxis: {
              categories: ['Autocontrol y estabilidad emocional', 'Confianza y seguridad en sí mismo', 'Resistencia a la adversidad', 'Comunicación', 'Establecimiento de relaciones', 'Negociación', 'Trabajo en equipo', 'Iniciativa', 'Orientación a resultados', 'Capacidad de análisis', 'Toma de decisiones', 'Conocimiento de la institución', 'Orientación al usuario', 'Apertura', 'Identificación con la institución', 'Dirección', 'Liderazgo', 'Planificación y organización', 'Visión y Anticipación'],
              crosshair: true,
              labels: {
                style: {
                  color: "#fff"
                }
              }
            },
            yAxis: {
              min: 0,
              max: 4,
              title: {
                text: 'Puntaje',
                style: {
                  color: "#fff"
                }
              },
              labels: {
                style: {
                  color: "#fff"
                }
              }
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              itemStyle: {
                color: '#FFF'
              }
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              }
            }, exporting: {
              buttons: {
                contextButton: {
                  symbolStroke: "white",
                  theme: {
                    fill: "transparent"
                  }
                }
              }
            },
            series: [{
              name: 'Perfil del Puesto',
              data: [3.2, 2.4, 2, 1.7, 3, 3.1, 3.3, 2.7, 2, 3.1, 3, 2, 1.5, 1.4, 1.8, 3, 3.5, 2]

            }, {
              name: 'Resultado',
              data: [],
              color: '#cfcdcc'

            }]

          }
        }


      },
      cargarDatosEvaluacion: function () {//Hace la petición para recibir los datos generales sobre la evaluación a mostrar
        //Carga los datos para hacer la peticion
        var peticion = {
          "esPrueba": false,
          "idEvaluacion": this.idEvaluacion
        };
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {
            console.log(response.data)
            var evaluacion = response.data.evaluacion
            this.estatus = evaluacion.Estatus
            if (this.estatus == "Terminado") {
              this.terminado = true
            }
            var evaluadores = response.data.evaluacion.evaluadores
            this.asignadosIniciales = (evaluadores.length > 0)
            if (this.asignadosIniciales) {
              this.buscarEvaluadoresAsignados();
            }
            this.nombreEvaluado = evaluacion.nombreEvaluado
            this.seccion = evaluacion.Seccion
            this.departamento = evaluacion.Departamento
            this.puesto = evaluacion.Puesto
            this.tipoPuesto = evaluacion.TipoPlaza
            this.periodoEvaluacion = evaluacion.FechaInicioPeriodoEvaluacionString + " - " + evaluacion.FechaFinPeriodoEvaluacionString
            this.evaluadoresAsignados = evaluacion.noCuestionarios
            this.evaluadoId = evaluacion.EvaluadoId
            this.comentario = evaluacion.ObservacionRH
            if (evaluacion.PerfilCategorias[4] == null) {
              this.chartOptions.xAxis.categories.splice(4, 1)
              evaluacion.PerfilCategorias.splice(4, 1)
              evaluacion.ResultadoCategorias.splice(4, 1)
            }
            this.chartOptions.series[0].data = evaluacion.PerfilCategorias
            this.chartOptions2.series[0].data = evaluacion.PerfilCompetencias
            this.chartOptions.series[1].data = evaluacion.ResultadoCategorias
            this.chartOptions2.series[1].data = evaluacion.ResultadoCompetencias

            if (this.comentario != null) {
              this.comentado = true
            }
            //Extrae los resultados de la petición pára insertarlos en la vista
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      buscarEvaluadoresAsignados: function () {//Hace la petición para obtener a los evaluadores de la evaluación
        //Carga los valores requeridos para hacer la petición
        var peticion = {
          "esPrueba": false,
          "idEvaluacion": this.idEvaluacion
        };
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluadores, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa

            this.evaluadores = response.data.evaluadores//Carga los datos requeridos

          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }/*, cargarResultadosEvaluacion: function () {//Hace la petición para recibir los datos generales sobre la evaluación a mostrar
        //Carga los datos para hacer la peticion
        var peticion = {
          "esPrueba": false,
          "EvaluacionId": this.idEvaluacion
        };
        axios.post(api.conexion + api.SISEVA.funcion.GetResultadoEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {
            alert('hola')
            this.chartOptions.series[1].data = response.data.ResultadoCategorias
            this.chartOptions.xAxis.categories = response.data.NombreCategorias
            this.chartOptions2.series[1].data = response.data.ResultadoCompetencias
            this.chartOptions2.xAxis.categories = response.data.NombreCompetencias
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }*/,
      guardarComentario: function () {
        var peticion = {
          "esPrueba": false,
          "EvaluacionId": this.idEvaluacion,
          "comentario": this.comentario
        };
        axios.post(api.conexion + api.SIAP.funcion.GuardarComentarioEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta("Comentario guardado correctamente", null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      CancelarResultadoEvaluacion: function (idCuestionario) {
        var peticion = {
          "esPrueba": false,
          "idCuestionario": idCuestionario
        };
        axios.post(api.conexion + api.SISEVA.funcion.CancelarResultadoEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.cargarDatosEvaluacion();
            //this.cargarResultadosEvaluacion();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      QuitarEvaluador: function (idCuestionario) {
        var peticion = {
          "esPrueba": false,
          "idCuestionario": idCuestionario
        };
        axios.post(api.conexion + api.SISEVA.funcion.QuitarEvaluador, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.cargarDatosEvaluacion();
            //this.cargarResultadosEvaluacion();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }
    },
    computed: {

    }, mounted: function mounted() {//Carga la información de la evaluación y la lista de cuestionarios al principio
      this.cargarDatosEvaluacion();
      //this.cargarResultadosEvaluacion();
    }

  }

</script>

<style scoped>
  .thead-custom {
    background-color: #004746;
    color: white;
  }
  .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/DetallesEvaluacion.vue